export default "__VITE_ASSET__D1kL34hq__"